"use client";

import React, { useMemo } from "react";
import { showCaseComponentSwitch } from "@/components/showcase/showcase.utils";

import sortBy from "lodash/sortBy";

const ProgramScreen = ({ showcaseData }) => {
  const programData = useMemo(() => {
    let results = [];

    Object.keys(showcaseData)?.map((key) => {
      showcaseData[key]?.map((item) => results.push(item));
    });

    return sortBy(results, (x) => x.priority);
  }, [showcaseData]);

  return (
    <div className="h-auto min-h-[100vh] w-full pb-24">
      <div className="relative">
        <div className="relative w-full">
          <div className="relative w-full min-h-[400px]">
            <img
              src="/images/program-bg.svg"
              className="object-cover"
              alt="program"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            />
          </div>
          <div className="absolute top-[40%] left-[10vw] w-fit h-[75px] md:h-[100px] lg:h-[150px] z-10">
            <img
              src="/images/program-bg-icon.svg"
              className=""
              alt="icon"
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            />
          </div>
        </div>
        <div className="w-full relative overflow-visible mt-5 z-20">
          <div className="absolute left-0 bottom-[100%] right-0 h-[10vw] serial-shadow-alt"></div>
          <div className=" max-w-[1920px] mx-auto">
            <h2 className="font-medium sm:font-bold md:font-extrabold lg:font-black mr-5 sm:mr-11 lg:mr-[5.7rem] text-[#F0F0F0] mb-6 text-3xl md:text-4xl lg:text-5xl z-30 pt-2">
              برنامه
            </h2>
          </div>
        </div>
      </div>
      <div className="w-full mt-20">
        {programData?.length > 0 ? (
          programData?.map((item, index) => showCaseComponentSwitch(item, "program", index))
        ) : (
          <div className="flex justify-center items-center pt-28">
            <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#BFBFBF]">
              محتوایی یافت نشد.
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramScreen;
